<template>
  <section class="overview">
    <tips></tips>
    <xwallet-new></xwallet-new>
    <!--<xwallet></xwallet>-->
    <ubiquitous></ubiquitous>
    <private-wallet></private-wallet>
    <dapp></dapp>
    <telegram-chat></telegram-chat>
    <manage-assets></manage-assets>
    <!-- <payments></payments> -->
    <!-- <tokens/> -->
    <!-- <convert/> -->
    <security></security>
  </section>
</template>

<script>
// import xwallet from '../../views/overview/xwallet'

// import payments from '../../views/overview/payments'
import security from '../../views/overview/security'
import ubiquitous from '../../views/overview/ubiquitous'
import XwalletNew from "./xwalletNew";
// import convert from './convert'
// import Tokens from './tokens.vue'
import PrivateWallet from '../../views/overview/privateWallet'
import Dapp from '../../views/overview/dapp'
import TelegramChat from '../../views/overview/telegramChat'
import ManageAssets from '../../views/overview/manageAssets'
import Tips from "@/views/overview/tips.vue";

  export default {
    name: "overview",
    components: {
      Tips,
      XwalletNew,
      // payments,
      security,
      // convert,
      ubiquitous,
      // Tokens,
      PrivateWallet,
      Dapp,
      TelegramChat,
      ManageAssets
    }
  }
</script>

<style scoped>
.overview{
  /* opacity: 0.94; */
  /* background-image: linear-gradient(-180deg, #000000 0%, #1E1E1E 100%); */
}
</style>